// extracted by mini-css-extract-plugin
export default {"columnTitle":"QuickLinksColumns-module--columnTitle--0a898","columnLink":"QuickLinksColumns-module--columnLink--42f1a"};